<template>
  <div class="container" v-show="!start">
    <div class="chevron" :class="theme"></div>
    <div class="chevron" :class="theme"></div>
    <div class="chevron" :class="theme"></div>
    <span class="text" :class="theme">{{downHintTxt }} <br/><br/> 下滑打开</span>
</div>
</template>

<script>
export default {
  name: 'DownHint',
  props: {
    msg: String,
    downHintTxt: String,
    theme: String
  },
  data() {
    return {
      start: false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
    position: relative;
    width: 100%;
    height: 100%;
}
.chevron {
  margin: 0 auto;
    width: 28px;
    height: 8px;
    opacity: 0;
    transform: scale3d(0.5, 0.5, 0.5);
    animation: move 3s ease-out infinite;
}
.chevron:first-child {
    animation: move 3s ease-out 1s infinite;
}
.chevron:nth-child(2) {
    animation: move 3s ease-out 2s infinite;
}
.chevron:before,
.chevron:after {
    content: ' ';
    position: absolute;
    top: 0;
    height: 100%;
    width: 51%;
    background: #fff;
}
.dark:before,
.dark:after {
    background: #000!important;
}
.dark{
  color: #000!important;
}
.red:before,
.red:after {
    background: red!important;
}
.red{
  color: red!important;
}
.chevron:before {
    left: 0;
    transform: skew(0deg, 30deg);
}
.chevron:after {
    right: 0;
    width: 50%;
    transform: skew(0deg, -30deg);
}
@keyframes move {
    25% {
        opacity: 1;
    }
    33% {
        opacity: 1;
        transform: translateY(30px);
    }
    67% {
        opacity: 1;
        transform: translateY(50px);
    }
    100% {
        opacity: 0;
        transform: translateY(70px) scale3d(0.5, 0.5, 0.5);
    }
}
.text {
    display: block;
    margin-top: 75px;
    font-size: 1rem;
    color: #fff;
    text-transform: uppercase;
    white-space: nowrap;
    opacity: .25;
    animation: pulse 2s linear alternate infinite;
}
.input-text{
  margin-bottom: 5px;
}
@keyframes pulse {
    to {
        opacity: 1;
    }
}
</style>
